export default function Logo({ size = 40, withText = false, className = "" }) {
  // The brand image is horizontal (799x400). When shown with text, use only the caduceus square crop.
  // When shown alone (mobile/compact), scale the full brand image.
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div
        className="rounded-xl overflow-hidden bg-white flex-shrink-0 shadow-sm"
        style={{ width: size, height: size }}
      >
        <img
          src="/dr-dimy-brand.jpeg"
          alt="Dr. Dimy Laguerre"
          className="w-full h-full object-cover object-left"
          style={{ transform: "scale(1.6)", transformOrigin: "18% center" }}
        />
      </div>
      {withText && (
        <div className="leading-tight min-w-0">
          <div className="font-display font-semibold tracking-tight text-foreground truncate">Dr. Dimy Laguerre</div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground mt-0.5">Consulta médica</div>
        </div>
      )}
    </div>
  );
}
